var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1666 69.1668L73.5416 39.7918L67.7083 33.9585L44.1666 57.5002L32.2916 45.6252L26.4583 51.4585L44.1666 69.1668ZM49.9999 91.6668C44.236 91.6668 38.8194 90.5724 33.7499 88.3835C28.6805 86.1946 24.2708 83.2266 20.5208 79.4793C16.7708 75.7293 13.8027 71.3196 11.6166 66.2502C9.43047 61.1807 8.33603 55.7641 8.33325 50.0002C8.33325 44.2363 9.4277 38.8196 11.6166 33.7502C13.8055 28.6807 16.7735 24.271 20.5208 20.521C24.2708 16.771 28.6805 13.8029 33.7499 11.6168C38.8194 9.43072 44.236 8.33627 49.9999 8.3335C55.7638 8.3335 61.1805 9.42794 66.2499 11.6168C71.3194 13.8057 75.7291 16.7738 79.4791 20.521C83.2291 24.271 86.1985 28.6807 88.3874 33.7502C90.5763 38.8196 91.6694 44.2363 91.6666 50.0002C91.6666 55.7641 90.5721 61.1807 88.3833 66.2502C86.1944 71.3196 83.2263 75.7293 79.4791 79.4793C75.7291 83.2293 71.3194 86.1988 66.2499 88.3877C61.1805 90.5766 55.7638 91.6696 49.9999 91.6668Z",
    fill: "url(#paint0_linear_594_5476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_594_5476",
    x1: 8.33325,
    y1: 50.0002,
    x2: 91.6666,
    y2: 50.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0966AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9EE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6fe2d67245bce3b8a3eb5c834c7ae887.svg";
export { ForwardRef as ReactComponent };